import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  IconButton,
  Link,
} from "@material-ui/core";
import { OTPInput } from "./OTPInput";
import { useOtpStyles } from "./otpStyles";
import Alert from 'react-s-alert';
import { ArrowBackIos } from "@material-ui/icons";
import ApiServices from "service/ApiServices";

export default function OTPModal({ open, disableSelectOption, nextProcess, onClose, userData }) {
  const classes = useOtpStyles();

  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const [channel, setChannel] = useState("email");
  const [canResend, setCanResend] = useState(false);
  const [clearMessage, setClearMessage] = useState(60);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (step !== 2) return;

    if (timer <= 0) {
      setCanResend(true);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, step]);

  //limpieza automática del mensaje
  useEffect(()=>{
    if (!errorMessage) return;

    const interval = setTimeout(()=>{
      setErrorMessage("")
    }, 4000);

    return () => clearTimeout(interval);
  },[errorMessage])

  // envío de código OTP
  const handleSendOtp = async () => {
    setLoading(true);
    if (!channel) return alert("Selecciona una opción");

    let requestBody = {
      "channel": channel,
      "destination": channel === "sms" ? userData.phoneNumber : userData.email,
      "userName": `${userData.firstName} ${userData.firstLastName}`,
    }

    try {
      const response = await ApiServices.validarOtp.enviar(requestBody)
      if(response.error != null){
        Alert.error(response.error);
      } else {
        Alert.success(response.data);
        setStep(2);
      }
    } catch (error) {
      Alert.error(error);
    } finally {
      setLoading(false);
    }

    setTimer(60);
    setCanResend(false);
  };

  // reenvío de código OTP
  const handleResendOtp = async () => {
    setOtp("")
    setErrorMessage("");
    let requestBody = {
      "channel": channel,
      "destination": channel === "sms" ? userData.phoneNumber : userData.email,
      "userName": `${userData.firstName} ${userData.firstLastName}`,
    }

    try {
      const response = await ApiServices.validarOtp.enviar(requestBody)
      if(response.error != null){
        setErrorMessage(response.error);
      } else {
        Alert.success(response.data);
      }
    } catch (error) {
      setErrorMessage(error);
    }

    setTimer(60);
    setCanResend(false);
  };

  // Verificación de código OTP
  const handleVerifyOtp = async () => {
    setLoading(true);
    if (otp.length !== 6) return setErrorMessage("Código incompleto");

    let requestBody = {
      "channel": channel,
      "destination": channel === "sms" ? userData.phoneNumber : userData.email,
      "username": `${userData.firstName} ${userData.firstLastName}`,
      "otpCode" : otp
    }

    try {
      const response = await ApiServices.validarOtp.verificar(requestBody)
      if(response.error != null) {
        setErrorMessage(response.error)
      } else {
        Alert.success(response.data)
        nextProcess();
      }
    } catch (error) {
      setErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setStep(1);
    setOtp("");
    setTimer(60);
    setCanResend(false);
    setErrorMessage("");
  };

  useEffect(() => {
  if (!open) {
      setStep(1);
      setOtp("");
      setTimer(60);
      setCanResend(false);
      setErrorMessage("");
    }
  }, [open]);


  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth >
      <DialogContent>
        <Box className={classes.container}>
          {step === 1 && (
            <>
              <Typography variant="h6" align="center" className={classes.titleStep}>
                Obtener código
              </Typography>

              <Typography variant="h6" align="center" className={classes.description}>
                Selecciona el medio por donde deseas recibir el código de verificación.
              </Typography>

              <TextField
                select
                variant="outlined"
                value={channel}
                onChange={(e) => setChannel(e.target.value)}
              >
                <MenuItem value="email">Email</MenuItem>
                <MenuItem disabled={disableSelectOption} value="sms">SMS</MenuItem>
              </TextField>

              <Button 
                color="primary" 
                variant="contained" 
                onClick={handleSendOtp} 
                className={classes.verifyButton}
                disabled={loading}
              >
                {loading ? "Enviando..." : "Obtener"}
              </Button>
            </>
          )}

          {step === 2 && (
            <>
              <div style={{display: "flex"}}>
                <IconButton aria-label="back-step" onClick={handleBack}>
                  <ArrowBackIos/>
                </IconButton>
                <Typography variant="h6" align="center" className={classes.titleStep}>
                  Ingresa el código
                </Typography>
              </div>

              <Typography variant="h6" align="center" className={classes.description}>
                Te hemos enviado un código, por favor ingresalo aquí.
              </Typography>

              <OTPInput value={otp} onChange={setOtp} />

              {errorMessage && (
                <Typography className={classes.errorMessage}>
                  {errorMessage}
                </Typography>
              )}

              <Button
                  color="primary"
                  variant="contained"
                  onClick={handleVerifyOtp}
                  className={classes.verifyButton}
                >
                  Verificar
              </Button>

              <Typography className={classes.resendText}>
                {canResend ? (
                  <>
                    <>No tienes un código? </>
                    <Link
                      component="button"
                      variant="body2"
                      underline="always"
                      onClick={handleResendOtp}
                      className={classes.linkStyle}
                    >
                      Click para reenviar
                    </Link>
                  </>
                ) : (
                  <>No recibiste el código? <b>Podrás reenviar en {timer}s</b></>
                )}
              </Typography>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
